import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsRowModel } from 'src/app/models/widgets/widgets-row.model';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { CdkDrag, CdkDragDrop } from '@angular/cdk/drag-drop';
import { WidgetsContainerComponentAbstract } from 'src/app/abstract/widgets/widgets-container-component.abstract';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { CommandService } from 'src/app/services/command/command.service';
import { Logger } from 'src/app/core/logger';
import { WidgetsNotifyDeleteService } from 'src/app/services/widgets/widgets-notify-delete.service';
import { WidgetsSelectionService } from 'src/app/services/widgets/widgets-selection.service';

@Component({
  selector: '[appWidgetsRow]',
  templateUrl: './widgets-row.component.html',
  styleUrls: ['./widgets-row.component.scss']
})
export class WidgetsRowComponent extends WidgetsContainerComponentAbstract implements OnInit {
  @Input() data: WidgetsRowModel = new WidgetsRowModel();
  @Input() dropListIds: string[] = [];
  @Output() dropListIdAdded: EventEmitter<string> = new EventEmitter<string>();

  fields: string[] = [];
  hidefield: string = '';
  
  constructor(private widgetsService: WidgetsService,
    private selectionService: WidgetsSelectionService,
    private commandService: CommandService,
    private notifyDeleteService: WidgetsNotifyDeleteService,
    private logger: Logger) {  
    super();
  }

  ngOnInit(): void {
    this.onRefreshFields();
  }

  onRefreshFields(): void {
    this.fields = this.widgetsService.getAllFieldsOfType('');
  }
  
  onHide($event:any) {
    this.data.template = "{ \"expressions\": { hide: \"!model."+this.hidefield+"\"}}";
  } 

  onWidgetDroppedToCanvas(event: CdkDragDrop<WidgetsAbstract[], WidgetsAbstract[], any>): WidgetsAbstract {    
    return this.commandService.execute(this.data, event.item.data);
  }

  isDroppableWidget(item: CdkDrag<WidgetsAbstract>): boolean {
    // Constraints: Only COLUMNS are allowed under a ROW
    switch (item.data.widgetType) {
      case WidgetsTypeEnum.COLUMN:
        return true;
    }

    return false;
  }

  onDeleteModal(): void {
    this.notifyDeleteService.notifyDelete(this.data);
  }

  clone(WidgetsAbstract: any): WidgetsAbstract {
    throw new Error('Method not implemented.');
  }

  onWidgetsReordered(culprits: WidgetsAbstract[]) {
    throw new Error('Method not implemented.');
  }

  onSelect($event) {
    this.selectionService.toggleSelection(this.data);
  }  
}
